class Monitoring.Methods.AsyncJob extends Backbone.View

  start: (jobsName, params) =>
    @job = new ResqueJob
      url: "/monitoring/dashboard/jobs/#{jobsName}"
      data: params
      success: (results) =>
        @trigger('completed', results)
      error: (results) =>
        @trigger('failed', results)
    @job.start()

  stop: ->
    @job.stop()
